App.TariffCardComponent = Em.Component.extend
  classNames: [ 'tariff-card' ]

  classNameBindings: [
    'isSelected:selected'
  ]

  isSelected: (->
    @get('selectedTariff.id') is @get('tariff.id')
  ).property('selectedTariff.id', 'tariff.id')

  actions:
    selectTariff: ->
      @set('selectedTariff', @get('tariff'))
      false
